import memoize from 'lodash-es/memoize';

/**
 * Memorize the result of a function based on the first argument
 *
 * See {@link https://lodash.com/docs/#memoize}
 */
export function Memoize() {
  return function (
    target: unknown,
    functionName: string,
    descriptor: PropertyDescriptor,
  ) {
    if (descriptor.get) {
      descriptor.get = memoize(descriptor.get, function <T>(this: T): T {
        return this;
      });
    } else {
      descriptor.value = memoize(descriptor.value);
    }
  };
}
